import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { bool, func, string } from "prop-types";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";

class Action extends Component {
    static propTypes = {
        handleClick: func,
        className: string,
        labelKey: string,
        to: string,
        disabled: bool,
    };

    static defaultProps = {
        handleClick: null,
        className: null,
        labelKey: null,
        to: null,
        disabled: false,
    };

    handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const { handleClick } = this.props;

        if (handleClick) {
            handleClick();
        }
    };

    render() {
        const { className, labelKey, to, disabled } = this.props;

        return (
            (to && (
                <Link
                    className={className || classNames(`btn`)}
                    to={to}
                    style={{
                        pointerEvents: disabled ? "none" : "",
                    }}>
                    <I18n id={labelKey} />
                </Link>
            )) || (
                <Button
                    className={className}
                    label={labelKey}
                    onClick={this.handleClick}
                    bsStyle="link"
                    disabled={disabled}
                />
            )
        );
    }
}

export default Action;
